import { create } from 'zustand';
import { TransformedCard } from '../api/lib/utils/transform-program';

type State = {
    favoritePrograms: TransformedCard[];
};

type Actions = {
    actions: {
        setFavoriteProgramms: (state: State['favoritePrograms']) => void;
    };
};

export const useFavoriteProgramsStore = create<State & Actions>((set) => ({
    favoritePrograms: [],
    actions: {
        setFavoriteProgramms: (newState) => set(() => ({ favoritePrograms: newState })),
    },
}));

export const useFavoriteProgramsValue = () => useFavoriteProgramsStore((state) => state.favoritePrograms);
export const useFavoriteProgramsSetState = () =>
    useFavoriteProgramsStore((state) => state.actions.setFavoriteProgramms);
